import React from 'react';
import { Link } from 'react-router-dom';

const GallerySection = () => {
    return (
        <section className="gallerySection padd-30">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="commanHead">
                            <h2> Gallery </h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-sm-6 col-xs-12 plr-0 outr">
                        <img src="../assets/images/gallery/1.jpg" className="img1" alt="Gallery Image 1" />
                        <div className="content-overlay"></div>
                    </div>
                    <div className="col-md-3 col-sm-6 col-xs-12 plr-0 outr">
                        <img src="../assets/images/gallery/3.jpg" className="img1" alt="Gallery Image 3" />
                        <div className="content-overlay"></div>
                    </div>
                    <div className="col-md-3 col-sm-6 col-xs-12 plr-0 outr">
                        <img src="../assets/images/gallery/5.jpg" className="img1" alt="Gallery Image 5" />
                        <div className="content-overlay"></div>
                    </div>
                    <div className="col-md-3 col-sm-6 col-xs-12 plr-0 outr">
                        <img src="../assets/images/gallery/7.jpg" className="img1" alt="Gallery Image 7" />
                        <div className="content-overlay"></div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12 text-center">
                        <Link to="/gallery" className="popart-btn" data-form="order-form" data-btn-type="open-form">
                            <i className="fa fa-hand-point-right"></i> View All
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GallerySection;
